import { Component, OnInit, Input, effect } from '@angular/core';
import { Student, AdmissionsService, UIConfiguration, DispositionService, DncDispositionRequested, DialerContactService, UserService, DialerContactResponse } from '../../../lib';
import { AdmissionUIMessengerService } from '../admission-ui-messenger.service';
import { GenesysSparkWrapperService } from '../genesys-spark-wrapper.service';
import { ToastService } from '../../toast/toast.service';
import { Subject } from 'rxjs';
import { LeadConversationState, LeadConversationStateStore } from '../../dialpad/leadConversation.state';
import { AdmissionUICommonDataService } from '../admission-ui-common-data.service';

@Component({
  selector: 'app-dncscreen',
  templateUrl: './dncscreen.component.html',
  styleUrl: '../admission-ui.component.scss'
})
export class DNCScreenComponent implements OnInit {
  @Input() buttonType: string = 'primary';
  @Input() conversationId: string | undefined = '';
  @Input() callSkills: string[] = [];
  @Input() previousUserCallStatus: string = 'Available';

  studentId!: number;

  isLoading: boolean = true;

  studentData: Student | undefined;
  inquiryId: number | undefined;
  dialerContactId: number | undefined;
  syStaffId: number | undefined;
  accountId: number | undefined;
  callStatus: string = 'Waiting';
  callType: string = 'OutgoingCall';

  uiConfiguration: UIConfiguration[] | undefined;

  showStudentId: boolean = false;

  today: number = Date.now();

  comments: string = '';
  emailConversationId: string | undefined | null = null;

  telecomDialerCampaignName: string | null | undefined;
  dispositionNotifyNoActionLimit: number = 0;
  noActionTimer: number = 0;
  bannerWarning: boolean = false;
  iDashURL: string = '';

  private leadConversationState: LeadConversationState = {};
  constructor(
    private readonly messenger: AdmissionUIMessengerService,
    private readonly dispositionService: DispositionService,
    private readonly admissionsService: AdmissionsService,
    private readonly dialerService: DialerContactService,
    private readonly genesysSparkWrapperService: GenesysSparkWrapperService,
    private readonly userService: UserService,
    private readonly toastService: ToastService,
    private readonly leadConversationStateStore: LeadConversationStateStore,
    private readonly commonDataService: AdmissionUICommonDataService,
  ) {
    effect(() => {
      this.leadConversationState = this.leadConversationStateStore.getState()();
      this.callStatus = this.leadConversationState.CallStatus ?? 'Not Set';
      this.studentData = this.leadConversationState.Student;
      this.studentId = this.leadConversationState?.Student?.id!;
      this.conversationId = this.leadConversationState.Call?.id ?? this.leadConversationState.Email?.id;
      this.callType = this.leadConversationState.CallType ?? 'OutgoingCall';
      this.previousUserCallStatus = this.leadConversationState?.PreviousUserStatus ?? "Available";
      this.emailConversationId = this.leadConversationState.Email?.id;
    });
  }


  ngOnInit() {

    this.genesysSparkWrapperService.register().then(() => {
      this.userService.apiAccountGet().subscribe(data => {
        this.accountId = data.id;
      });
      this.userService.apiSyStaffGet().subscribe(data => {
        this.syStaffId = data.id;
      });
      if (this.studentData) {
        this.inquiryId = this.studentData?.inquiries?.find(obj => obj.isCurrent === true)?.id;
        if (this.inquiryId) {
          this.dialerService.apiDialerContactGetByInquiryIdGet(this.inquiryId).subscribe( (data : DialerContactResponse) => {
            this.dialerContactId = data.id;
            this.telecomDialerCampaignName = data.telecomDialerCampaignName;
            if (data.leadSkills) {
              data.leadSkills.forEach(skill => {
                if (skill.id) {
                  this.callSkills.push(skill.id);
                }
              });
            }

          });
        }
      }
      this.isLoading = false;
    });
    this.admissionsService.apiGetUIConfigurationGet().subscribe(data => {
      this.uiConfiguration = data;
      this.showStudentId = this.uiConfiguration?.find(obj => obj.key === 'DispositionWindow.ShowStudentId.Enable')?.value === '1'
      const iDashBaseURL = this.uiConfiguration?.find(obj => obj.key === 'LsIdash.Url')?.value;
      if (iDashBaseURL && this.studentData?.id !== undefined) {
        this.iDashURL = iDashBaseURL + this.studentData?.id;
      }
      const notifyNoActionTime = this.uiConfiguration?.find(obj => obj.key === 'Disposition.NotifyNoActionSeconds')?.value;
      if (notifyNoActionTime) {
        this.dispositionNotifyNoActionLimit = parseInt(notifyNoActionTime);
      }
      this.startBannerTimer();
    });

  }

  startBannerTimer() {
    if (this.dispositionNotifyNoActionLimit && this.dispositionNotifyNoActionLimit != undefined) {
      this.noActionTimer = this.dispositionNotifyNoActionLimit;
      if (this.noActionTimer && this.noActionTimer != undefined) {
        const interval = setInterval(() => {
          if (this.noActionTimer <= 0) {
            this.bannerWarning = true;
            clearInterval(interval);
          }
          this.noActionTimer--;
        }, 1000)
      }
    }
  }

  submitDNC() {
    const DNCDisposition: DncDispositionRequested = {
      conversationId: this.conversationId!,
      reason: { id: this.commonDataService.doNotCall?.id, value: this.commonDataService.doNotCall?.value },
      dialerContactId: this.dialerContactId,
      interactionType: this.callType,
      skills: this.callSkills,
      interviewResult: '',
      syStudentId: this.studentData?.id,
      comments: this.comments,
      telecomDialerCampaignName: this.telecomDialerCampaignName,
      syStaffId: this.syStaffId,
      syStudentInquiryId: this.inquiryId,
      accountId: this.accountId,
      phoneNumber: this.studentData?.phoneDigits,
      admissionRepresentativeId: this.studentData?.admissionsRepresentative ? this.studentData?.admissionsRepresentative.id : undefined
    }

    this.dispositionService.apiDispositionDNCDispositionRequestedPost(DNCDisposition).subscribe(resp => {
      if (resp.success !== true) {
        this.toastService.show({ body: 'Disposition failed.', classname: 'bg-danger text-light', delay: 5000, header: 'Disposition Failed' });
      }
      if (this.emailConversationId) {
        this.leadConversationStateStore.disconnectDispostionedEmail().subscribe(() => {
          this.commonDataService.toggleUserStatus(this.previousUserCallStatus).subscribe(() => { });
        });
      }
      else {
        this.leadConversationStateStore.endInteraction(DNCDisposition.phoneNumber!);
        this.commonDataService.toggleUserStatus(this.previousUserCallStatus).subscribe(() => { });
      }
    })
  }

  cancel() {
    this.messenger.setPage('Disposition');
  }

}